import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=ce7f20b0&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=ce7f20b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7f20b0",
  null
  
)

export default component.exports